/* global globalThis */

const getSubtleCrypto = (): SubtleCrypto => {
  const subtleCrypto = globalThis.crypto?.subtle;

  if (!subtleCrypto) {
    throw new Error('SHA-256 hashing requires globalThis.crypto.subtle');
  }

  return subtleCrypto;
};

export const sha256 = async (value: string): Promise<string> => {
  const data = new TextEncoder().encode(value);
  const hashBuffer = await getSubtleCrypto().digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};
